import { CdkDragDrop, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { Storage } from '@angular/fire/storage';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CustomFile } from '../../services/model';
import { OfficeService } from '../../services/office.service';
import { UploadDialogComponent } from '../upload-dialog/upload-dialog.component';

@Component({
  selector: 'app-file-upload',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatListModule,
    DragDropModule,
    MatProgressBarModule,
    MatDialogModule,
  ],
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.scss',
})
export class FileUploadComponent {
  storage = inject(Storage);
  firestore: Firestore = inject(Firestore);
  officeService = inject(OfficeService);
  cdr = inject(ChangeDetectorRef);

  @Input() files: CustomFile[] = [];
  @Output() changeFiles = new EventEmitter<CustomFile[]>(true);

  constructor(public dialog: MatDialog) {}

  // Reihenfolge ändern
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.files, event.previousIndex, event.currentIndex);
    this.changeFiles.emit(this.files);
  }

  openUploadDialog() {
    const dialogRef = this.dialog.open(UploadDialogComponent, {
      data: this.officeService.officePath(),
      width: '400px',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result: CustomFile) => {
      if (result) {
        // Neue Datei zur Liste hinzufügen
        this.files.push({ ...result, order: this.files.length });
        this.changeFiles.emit(this.files);
        this.cdr.detectChanges();
      }
    });
  }
}
